import Countdown from "react-countdown";

export default function Timer({ mill, end, status, handleSetTimer }) {

    let dateTime = Date.now() + mill;

    const renderer = ({ hours, minutes, seconds, completed }) => {
        let milisegunSegundos = seconds * 1000;
        let milisegunMinutos = minutes * 60000;
        let tiempoFinal = milisegunSegundos + milisegunMinutos;
        handleSetTimer(tiempoFinal);
        if (completed) {
            return (
                <span className='timer-span tx-primary tx-bold'>
                    {end()}
                </span>
              );
        } else {
          return (
            <span style={{display: status ? 'none' : 'block'}} className='timer-span tx-primary tx-bold'>
                { String(minutes).length === 1 
                    ? `0${minutes}` 
                    : minutes }:
                { String(seconds).length === 1 
                    ? `0${seconds}` 
                    : seconds } 
            </span>
          );
        }
    };

    return (
        <Countdown date={dateTime} renderer={renderer} />
    )
}